import { getEmployeeUsability } from '../../../shared/data-services/employee-services';
import { Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { alignProperty } from '@mui/material/styles/cssUtils';
import dayjs from "dayjs";

const BoldHeader = styled("span")({
    fontWeight: "bold"
});

export async function getMonthsView(strfechaInicio, strfechaFin) {
    const fechaInicio = new Date(strfechaInicio);
    const fechaFin = new Date(strfechaFin);
    const data = [];

    while (fechaFin >= fechaInicio) {
        const Month = new Intl.DateTimeFormat('es-CO', { month: "long" }).format(new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), 1));
        data.push({
            Year: fechaInicio.getFullYear(),
            Month: Month.charAt(0).toUpperCase() + Month.slice(1)
        });
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
    }
    return data;
};

export async function getData(params) {
    //console.log(params);
    const data = await getEmployeeUsability(params);
    //console.log(data);
    return data.map((element, index) => ({
        "id": element.moduleUsabilityLogId || index,
        "employeeId": element.employeeId,
        "employeeName": element.employeeName,
        "employeePosition": element.employeePosition,
        "airport": element.airport,
        "module": element.module,
        "lastUsedModuleDate": element.lastUsedModuleDate ? dayjs(element.lastUsedModuleDate).format('YYYY-MM-DD HH:mm'): ""
    }));
};


export async function getDataExport(params) {
    const data = await getData(params);
    const dataReal = [];

    
    data.forEach(element => {
        const itemReal = [
            
            { v: element.employeeId, t: "s" },
            { v: element.employeeName, t: "s" }, 
            { v: element.employeePosition, t: "s" }, 
            { v: element.airport, t: "s" },
            { v: element.module, t: "s" }, 
            { v: element.lastUsedModuleDate, t: "s" }
        ];
    
        dataReal.push(itemReal);
    });

    return dataReal;
};

export async function getColumns(dataShift) {
    return [
        {
            field: 'id',
            headerName: 'ID',
            width: 60,
            hide: true
        },
        
        {
            field: 'employeeId',
            headerName: 'Identificación',
            width: 150,
            renderHeader: () => <BoldHeader>Identificación</BoldHeader>
        },
        {
            field: 'employeeName',
            headerName: 'Nombre completo',
            width: 350,
            renderHeader: () => <BoldHeader>Nombre completo</BoldHeader>
        },
        {
            field: 'employeePosition',
            headerName: 'Cargo',
            width: 250,
            renderHeader: () => <BoldHeader>Cargo</BoldHeader>
        },
        {
            field: 'airport',
            headerName: 'Base',
            width: 70,
            align: 'center',
            renderHeader: () => <BoldHeader>Base</BoldHeader>
        },
        {
            field: 'module',
            headerName: 'Módulo',
            width: 250,
            renderHeader: () => <BoldHeader>Módulo</BoldHeader>
        },
        {
            field: 'lastUsedModuleDate',
            headerName: 'Fecha último uso',
            width: 150,
            renderHeader: () => <BoldHeader>Fecha último uso</BoldHeader>
        }
    ];
}

